import { useAuth } from "@/context/AuthContext";
import { KMark } from "@/components/KLogo";
import { Clock, LogOut } from "lucide-react";

export default function PendingScreen() {
  const { user, logout, refresh } = useAuth();
  return (
    <div className="min-h-[100dvh] bg-background relative flex items-center justify-center px-5">
      <div className="absolute inset-0 aurora opacity-70" />
      <div className="relative max-w-md w-full glass-strong rounded-3xl border border-white/10 p-8 text-center float-in glow-soft">
        <div className="inline-flex mb-5"><KMark size={64} /></div>
        <div className="w-12 h-12 rounded-full bg-yellow-500/15 border border-yellow-500/30 flex items-center justify-center mx-auto mb-4">
          <Clock className="w-6 h-6 text-yellow-400" />
        </div>
        <h1 className="font-display font-bold text-2xl tracking-tight">Aguardando aprovação</h1>
        <p className="text-sm text-muted-foreground mt-3">
          Olá, {user?.name?.split(" ")[0]}! Seu cadastro foi enviado para o síndico.
          Assim que aprovado, você terá acesso completo à comunidade do seu condomínio.
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <button onClick={refresh} data-testid="pending-refresh" className="rounded-full brand-gradient py-3 font-semibold text-white active:scale-95 transition-transform">
            Já fui aprovado — atualizar
          </button>
          <button onClick={logout} data-testid="pending-logout" className="flex items-center justify-center gap-2 rounded-full bg-white/5 border border-white/10 py-3 font-medium hover:bg-white/10 transition-colors">
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </div>
    </div>
  );
}
